import { SourcingStatus } from 'api-clients/monolith';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

export const useSourcingStatus = (status: SourcingStatus) => {
  const intl = useIntl();

  return useMemo(() => {
    switch (status) {
      case 'active':
        return {
          bgColor: 'bg-fx-green-50',
          title: intl.formatMessage({
            defaultMessage: 'Active',
            description: 'Title shown when the sourcing status is active.',
          }),
          tooltip: intl.formatMessage({
            defaultMessage:
              'One or more campaigns are active OR applicants applied in last 24 hours.',
            description:
              'Indicates that either at least one job campaign is currently running, or applicants have applied within the last 24 hours. Keep the logical “OR” clear.',
          }),
        };
      case 'inactive':
      default:
        return {
          bgColor: 'bg-fx-neutral-100',
          title: intl.formatMessage({
            defaultMessage: 'Inactive',
            description: 'Title shown when the sourcing status is inactive.',
          }),
          tooltip: intl.formatMessage({
            defaultMessage:
              'No active campaigns AND no applicants in last 24 hours.',
            description:
              'Indicates that there are no active job campaigns and no applicants have applied in the last 24 hours. Keep the logical “AND” clear.',
          }),
        };
    }
  }, [status, intl]);
};
